import {Provider} from '@/bank/bank.types'
import {Account} from '@/bank/account/account.types'

export type Consent = {
    uuid: string
    /**
     * @deprecated Use initiatedAtTenantId
     */
    tenantId: string
    orgNo: string
    bic: string
    userId: string
    userEmail: string
    status: ConsentStatus
    origin: Provider
    consentUrl?: string
    externalStatus?: string
    validUntil?: Date
    initiatedAtTenantId: string
    version: string
}

export enum ConsentStatus {
    unknown = 'unknown', processing = 'processing', unsuccessful = 'unsuccessful',
    canceled = 'canceled', active = 'active', replaced = 'replaced', revoked = 'revoked'
}

export type RefreshConsentAccountsResponse = {
    accounts: Account[]
}

export type RevokeConsentResponse = {
    consent: Consent
}

export type InitiateConsentCommand = {
    orgNo: string
    bic: string
    bankUserId: string
    redirectUrl: string
}

export type CheckConsentStatusCommand = {
    consentUuid: string
}

export type RefreshConsentAccountsCommand = {
    consentUuid: string
}

export type RevokeConsentCommand = {
    consentUuid: string
}
